import { render, staticRenderFns } from "./BaseSocialSignUpButton.vue?vue&type=template&id=77f69d48&scoped=true&"
import script from "./BaseSocialSignUpButton.vue?vue&type=script&lang=js&"
export * from "./BaseSocialSignUpButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseSocialSignUpButton.vue?vue&type=style&index=0&id=77f69d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f69d48",
  null
  
)

export default component.exports